var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6875 12.375C5.67708 12.375 4.81 12.0469 4.08625 11.3906C3.36208 10.7344 3 9.91667 3 8.9375C3 7.95833 3.36208 7.14062 4.08625 6.48437C4.81 5.82812 5.67708 5.5 6.6875 5.5H10.625L9.4375 4.3125C9.32292 4.19792 9.26562 4.05208 9.26562 3.875C9.26562 3.69792 9.32292 3.55208 9.4375 3.4375C9.55208 3.32292 9.69792 3.26562 9.875 3.26562C10.0521 3.26562 10.1979 3.32292 10.3125 3.4375L12.5625 5.6875C12.625 5.75 12.6694 5.81771 12.6956 5.89062C12.7215 5.96354 12.7344 6.04167 12.7344 6.125C12.7344 6.20833 12.7215 6.28646 12.6956 6.35938C12.6694 6.43229 12.625 6.5 12.5625 6.5625L10.3125 8.8125C10.1979 8.92708 10.0521 8.98438 9.875 8.98438C9.69792 8.98438 9.55208 8.92708 9.4375 8.8125C9.32292 8.69792 9.26562 8.55208 9.26562 8.375C9.26562 8.19792 9.32292 8.05208 9.4375 7.9375L10.625 6.75H6.6875C6.03125 6.75 5.46104 6.95833 4.97687 7.375C4.49229 7.79167 4.25 8.3125 4.25 8.9375C4.25 9.5625 4.49229 10.0833 4.97687 10.5C5.46104 10.9167 6.03125 11.125 6.6875 11.125H10.5C10.6771 11.125 10.8254 11.185 10.945 11.305C11.065 11.4246 11.125 11.5729 11.125 11.75C11.125 11.9271 11.065 12.0754 10.945 12.195C10.8254 12.315 10.6771 12.375 10.5 12.375H6.6875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.f0eb42d5a1ebf100a931f3ced459eedd.svg";
export { ForwardRef as ReactComponent };